import { render, staticRenderFns } from "./ToBuy.vue?vue&type=template&id=cd999a3c&scoped=true"
import script from "./ToBuy.vue?vue&type=script&lang=js"
export * from "./ToBuy.vue?vue&type=script&lang=js"
import style0 from "./ToBuy.vue?vue&type=style&index=0&id=cd999a3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd999a3c",
  null
  
)

export default component.exports